import React, { useState } from 'react';

import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NumberInput({
  label,
  value,
  name,
  onChange,
  min,
  max,
  disableHelperText,
  sx = {},
  ...rest
}) {
  const { t } = useTranslation();
  const [rangeExceeded, setRangeExceeded] = useState(false);
  const handleChange = (event) => {
    const val = event.target.value;

    if (
      val === '' ||
      (!isNaN(val) && Number(val) >= min && Number(val) <= max)
    ) {
      setRangeExceeded(false);
    } else {
      setRangeExceeded(true);
    }
    onChange(event);
  };

  return (
    <TextField
      type='number'
      min={min}
      max={max}
      label={label}
      value={value}
      name={name}
      onChange={handleChange}
      size='small'
      sx={{ maxWidth: '250px', height: '40px', ...sx }}
      error={rangeExceeded}
      helperText={
        disableHelperText ??
        (rangeExceeded && `${t('range_exceeded')}: ${min} - ${max}`)
      }
      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      onKeyDown={(e) => {
        if (['.', ',', 'e', 'E'].includes(e.key)) {
          e.preventDefault();
        }
      }}
      onInput={(e) => {
        e.target.value = e.target.value.replace(/[^0-9-]/g, '');
      }}
      {...rest}
    />
  );
}
